<template>
  <!-- 首年限时加费 -->
  <div>
    <Modal v-model="visible" width="1000px" title="限时加费" :footer-hide="true" :mask-closable="false" class="my-modal">
      <div class="tools-box right" v-if="!list || list.length == 0">
        <Button type="primary" @click="add">新增费用项</Button>
      </div>
      <Form ref="form" :model="bean" :label-width="90" class="page-form less" v-for="(bean, i) in list" :key="bean.key">
        <FormItem prop="expenseItem" label="费用项名称" :rules="$units.formRule.required('请输入费用项名称')">
          <Input v-model="bean.expenseItem" placeholder="请输入" :disabled="bean.disabled" />
        </FormItem>
        <FormItem class="btn-item">
          <Button type="primary" @click="add">新增费用项</Button>
          <Button type="error" @click="del(bean, i)" :disabled="bean.disabled">删除</Button>
        </FormItem>
        <FormItem prop="agreementId" label="关联协议">
          <Select v-model="bean.agreementId" clearable filterable style="width: 260px" @on-change="selectAgreement(bean)" :disabled="bean.disabled">
            <Option v-for="bean in agreementList" :key="bean.id" :value="bean.id">{{ bean.name }} </Option>
          </Select>
          <Button type="text" @click="goAgreement">去维护协议＞</Button>
        </FormItem>
        <FormItem prop="computeType" label="计算因子" :rules="$units.formRule.required('请选择计算因子')">
          <RadioGroup v-model="bean.computeType">
            <Radio label="1" :disabled="bean.disabled">规模保费</Radio>
            <Radio label="2" :disabled="bean.disabled" v-if="topItem.productCategory == 3">上游标保</Radio>
            <Radio label="3" :disabled="bean.disabled">首年基础费用</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem prop="expenseStartTime" :label-width="140" label="费用有效期开始日期" :rules="$units.formRule.required('请选择费用有效期开始日期')">
          <DatePicker
            transfer
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            split-panels
            :value="bean.expenseStartTime"
            @on-change="bean.expenseStartTime = $event"
            placeholder="请选择"
            :disabled="bean.disabled || bean.isSatrt"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem
          prop="expenseEndTime"
          :label-width="140"
          label="费用有效期结束日期"
          :rules="[$units.formRule.required('请选择费用有效期结束日期'), dateRule(bean)]"
        >
          <DatePicker
            transfer
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            split-panels
            :value="bean.expenseEndTime"
            @on-change="bean.expenseEndTime = $event"
            placeholder="请选择"
            :disabled="bean.disabled"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <Table :columns="columns" :data="bean.tempCommissionList">
          <template slot-scope="{ index }" slot="commission">
            <Input
              v-model="bean.tempCommissionList[index].commission"
              placeholder="请输入"
              class="table-input"
              :class="{ 'red-bor': bean.tempCommissionList[index].commissionError }"
              @input="inputChange(bean.tempCommissionList[index], $event)"
              :disabled="bean.disabled"
            />
          </template>
        </Table>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="cancel">取消</Button>
        <Button type="primary" @click="submit" :loading="loading">确定</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-modal ref="confirmModal"></confirm-modal>
  </div>
</template>
  
<script>
import confirmModal from '@/components/commons/confirmModal';
import activityBase from './activityBase.config.js';
import common from './common.config.js';
export default {
  mixins: [activityBase, common],
  components: { confirmModal },
  props: {
    curSupplier: null
  },
  data() {
    return {
      visible: false,
      loading: false,
      over: true,
      tableItem: {},
      agreementList: [], //协议列表
      topItem: {}
    };
  },
  computed: {},
  created() {},
  methods: {
    async open(e) {
      this.tableItem = e.tableItem;
      this.headList = e.headList;
      this.topItem = e.topItem;
      if (this.topItem.sourceType != 2) {
        return;
      }
      const status = await this.getStatus();
      if (status) {
        this.initData(true);
        this.getAgreementList();
      } else {
        this.openBaseModal();
      }
    },
    // 时间选择规则
    dateRule(bean) {
      return {
        required: true,
        message: '结束时间不可小于开始时间',
        trigger: 'change',
        validator(rule, value) {
          if (bean.expenseStartTime && bean.expenseEndTime && bean.expenseStartTime > bean.expenseEndTime) {
            return false;
          }
          return true;
        }
      };
    },
    // 跳转协议页面
    goAgreement() {
      this.$router.push('/offline/agreementManage/supplierAgreement');
    },
    // 获取协议列表
    getAgreementList() {
      this.$http({
        url: '/buz/covenant/read/list',
        type: 'POST',
        data: {
          insuranceSupplierId: this.curSupplier.companyId,
          covenantSource: 1,
          covenantType: this.curSupplier.companyType,
          productCode: this.topItem.productCode,
          pageNum: 1,
          pageSize: 999
        }
      }).then(res => {
        this.agreementList = res.data;
      });
    },
    // 选择协议
    selectAgreement(bean) {
      const data = this.agreementList.find(item => item.id == bean.agreementId);
      bean.expenseStartTime = data.startTime;
      bean.expenseEndTime = data.endTime;
    },
    // 新增
    add() {
      const data = JSON.parse(JSON.stringify(this.initItem));
      data.key = Date.now();
      this.list.unshift(data);
    },
    del(data, i) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认删除该费用项全部信息？'
        })
        .then(() => {
          if (data.id) {
            this.$http({
              url: '/buz/upcommission/delTempCommission',
              type: 'GET',
              data: {
                tempCommissionId: data.id
              }
            }).then(res => {
              this.$emit('reload');
              this.list.splice(i, 1);
            });
          } else {
            this.list.splice(i, 1);
          }
        });
    },
    cancel() {
      this.visible = false;
    },
    submit() {
      const formArr = this.$refs.form.map(item => item.validate());
      Promise.all(formArr).then(formList => {
        let hasErr = formList.includes(false);
        this.list.forEach(item => {
          item.tempCommissionList.forEach(item2 => {
            if (item2.commission === '') {
              hasErr = true;
              this.$set(item2, 'commissionError', true);
            } else {
              this.$set(item2, 'commissionError', false);
            }
          });
        });
        if (hasErr) {
          this.$notice.msg('请完善信息');
          return;
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.$http({
          url: '/buz/upcommission/configTempCommissionList',
          type: 'POST',
          data: this.list
        })
          .then(res => {
            this.$notice.msg('操作成功');
            this.$emit('reload');
            this.visible = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './itemCommon.scss';
.tools-box {
  padding-top: 15px;
}
</style>  